export const SEARCH_BAR = 'global_search';
